module.exports = "#define GLSLIFY 1\nvarying vec2 vUv;\n\nuniform float alpha;\n\nuniform vec3 colorA;\n\nuniform vec3 colorB;\n\nvarying vec2 ssPosition;\n\nvarying float vTimer;\n\nfloat when_lt(float x, float y) {\n   return max(sign(y - x), 0.0);\n}\n\nuniform float lightLength;\n\nvoid main()\n{\n\tfloat vv = mix(0.0, 1.0, smoothstep( lightLength, 0.0,  abs(vTimer - vUv.x) ));\n\t\n\tgl_FragColor = vec4(mix(colorA, colorB, ssPosition.x), vv);\n\t// gl_FragColor = vec4(vec3(1.0), vv);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/Trail/modules/trail/material/shader/occlusion.frag.glsl
// module id = sfsR
// module chunks = 1